import React from "react";
import ImageContentSection from "../../components/imagecontentsection/ImageContentSection";
import Servicecard from "../../components/servicecard/Servicecard";
import { ERPinfo, IndustryInfo } from "../../controller/Serviceinfo";
import CustomAccordion from "../../components/customaccordion/CustomAccordion";
import CardWidget from "../../components/card/Carddata";
import { cardVariants } from "../../controller/Cardinfo";
import styles from "../../components/card/Carddata.module.css";
import SeoPage from "../../components/seo/SeoPage";
import { ERP } from "../../controller/Images";
import OverlayCard from "../../components/OverlayCard/OverlayCard";
import BannerCard from "../bannercard/BannerCard";
import Buttons from "../../components/buttons/Buttons";
import { useNavigate } from "react-router-dom";
import ToolChips from "../../components/toolchips/ToolChips";
import {
  FiPackage,
  FiTool,
  FiSettings,
  FiActivity,
  FiScissors,
  FiTruck,
  FiCoffee,
  FiGrid,
  FiCpu,
} from "react-icons/fi";

const ERPSolutions = () => {
  const tools = [
    {
      name: "Tin Containers",
      path: "/insights/erp-product-videos-tour#tin-container",
      icon: FiPackage,
      thumbnail: "https://img.youtube.com/vi/5C96SYH34r0/hqdefault.jpg",
    },
    {
      name: "Plastic Moulding",
      path: "/insights/erp-product-videos-tour#plastic-moulding",
      icon: FiTool,
      thumbnail: "https://img.youtube.com/vi/AWn5S1Qbc7I/hqdefault.jpg",
    },
    {
      name: "Metal Fabrication",
      path: "/insights/erp-product-videos-tour#metal-fabrication",
      icon: FiSettings,
    },
    {
      name: "Pharmaceuticals",
      path: "/insights/erp-product-videos-tour#pharmaceuticals",
      icon: FiActivity,
    },
    {
      name: "Textiles",
      path: "/insights/erp-product-videos-tour#textiles",
      icon: FiScissors,
    },
    {
      name: "Auto Parts",
      path: "/insights/erp-product-videos-tour#auto-parts",
      icon: FiTruck,
    },
    {
      name: "Food Processing",
      path: "/insights/erp-product-videos-tour#food-processing",
      icon: FiCoffee,
    },
    {
      name: "Furniture & Interiors",
      path: "/insights/erp-product-videos-tour#furniture-interiors",
      icon: FiGrid,
    },
  ];
  const navigate = useNavigate();
  return (
    <>
      <SeoPage
        title="Transform Your Enterprise with our smart ERP managed services"
        description="Our certified ERP experts specialize in delivering end-to-end ERP managed services, from customization, implementation, maintenance, and to support for your unique business needs"
      />
      <div className="text-center mt-5  custom-space custom-space-padding">
        <h5 className="main_heading mt-4">
          ERP Solutions Built Around Your Business
        </h5>
        <p className="main_subheading pb-4">
          Running critical operations on disconnected tools and spreadsheets
          leads to inefficiencies, limited visibility, and missed opportunities.
          Our open-source ERP implementation services, powered by ERPNext, bring
          finance, inventory, sales, HR, manufacturing, and operations onto a
          single, unified platform.
        </p>
      </div>
      <div>
        {/* ERP Strategy & Consulting */}
        {/* <ImageContentSection
          title="Connected Systems. Smarter Decisions."
          content={[
            "Enterprise Resource Planning (ERP) is an integrated software solution that connects all your core business functions such as finance, inventory, sales, HR, and operations into a single, unified system. By centralizing data and automating processes, ERP helps businesses reduce manual work, eliminate inefficiencies, and gain real-time insights for smarter decision-making. Whether you’re a growing enterprise or an established organization, ERP is the backbone for scalable, streamlined operations.",
          ]}
          image= {ERP}
        /> */}
        <div className="px-3 px-md-5">
          <OverlayCard
            title="Connected Systems. Smarter Decisions."
            description={[
              "We partner with organizations across manufacturing, retail, pharma, and other industries to deliver scalable, cost-effective ERP solutions built on ERPNext. Rather than imposing rigid processes, we tailor the system to match how your teams work ensuring faster adoption and measurable productivity gains.",

              "Beyond core ERP, we enable intelligent automation, analytics, and AI-assisted insights to surface trends, exceptions, and operational signals giving leadership real-time visibility into performance and growth drivers.",

              "Our services cover the full ERP lifecycle, from discovery and migration to customization, training, and go-live, with flexible deployment models including handover to internal teams, managed SaaS, or bespoke hosting aligned to your compliance needs.",

              "Whether replacing legacy systems or implementing ERP for the first time, we ensure a smooth rollout with minimal disruption and long-term value.",
            ]}
            image={ERP}
            imageLeft={true}
          />
        </div>
        <div className="pt-5">
          <ToolChips
            title="ERP Demos for Every Manufacturing Vertical"
            items={tools}
          />
        </div>

        <div className="pb-5 custom-space-padding">
          <Servicecard
            data={ERPinfo}
            heading="Our Services "
            // subheading="We provide cutting-edge digital consulting, managed services, data & analytics, digital marketing, and staffing solutions designed to accelerate growth, enhance efficiency, and drive business transformation."
            sliceEndNum={9} // Optional
          />
        </div>

        <div className={`container-fluid custom-space-padding`}>
          <div className="row">
            <div className="text-center ">
              <h5 className={`main_heading ${styles.section_heading}`}>
                Explore Our Digital Solutions
              </h5>
            </div>

            {/* Single row with gap */}
            {IndustryInfo.map((item, index) => (
              <CardWidget
                key={item.id}
                title={item.title}
                subtitle={item.paragraph}
                list={item.list}
                icon={item.icon}
                variants={cardVariants[index % cardVariants.length]}
                row={3} // 👈 Correct usage
              />
            ))}
          </div>
        </div>
        <div className="custom-space-padding">
          <h2 className="main_heading">FAQs</h2>
          <CustomAccordion
            title="How does Bharat Clouds approach ERP implementation?"
            description="ERP implementation begins with a clear understanding of existing processes and operational challenges. ERPNext is carefully configured and optimised to align with real business workflows ensuring better visibility, controlled costs, and long-term scalability."
          />

          <CustomAccordion
            title="Can the ERP system be customised without increasing complexity?"
            description="Yes. ERPNext offers strong flexibility, and the focus remains on practical customisation adapting modules, reports, and workflows to suit business needs while avoiding unnecessary over-engineering or cost escalation."
          />

          <CustomAccordion
            title="What deployment options are available?"
            description="ERP can be deployed in multiple ways based on business priorities and IT readiness SaaS-based models, hosted on the client’s cloud infrastructure, or fully managed environments. A structured handholding approach is also available, enabling internal teams to gradually take ownership, with the option for continued long-term support."
          />

          <CustomAccordion
            title="Will the ERP integrate with our existing systems?"
            description="Integration is designed as a core component of the solution. ERP is seamlessly connected with accounting software, CRM tools, e-commerce platforms, and other applications creating connected systems that enable smarter, data-driven decisions."
          />

          <CustomAccordion
            title="When can tangible benefits be expected after go-live?"
            description="With structured deployment and user enablement, organisations often begin experiencing improved reporting, tighter inventory control, and stronger financial visibility within the first few months."
          />

          <CustomAccordion
            title="What kind of support is available after implementation?"
            description="Support extends beyond go-live through training, optimisation, upgrades, and advisory guidance. Whether businesses prefer ongoing managed support or periodic assistance after internal transition, flexible engagement models ensure sustained value delivery."
          />

          {/* <CustomAccordion
            title="What is ERP and why do businesses need it?"
            description="ERP integrates all core business functions into one system, reducing manual work, improving efficiency, and enabling real-time decision-making."
          />

          <CustomAccordion
            title="How long does ERP implementation take?"
            description="Implementation timelines vary based on complexity but typically range from 4 to 12 weeks for small to medium businesses."
          />

          <CustomAccordion
            title="Is ERP suitable for my industry?"
            description="Yes! ERP can be customized for manufacturing, retail, healthcare, construction, hospitality, and more."
          />

          <CustomAccordion
            title="Why ERPNext with Us?"
            description={[
              {
                bold: true,
                text: "We focus on business outcomes, not just ERP deployment.",
              },

              { bold: true, text: "Cost-effective without compromise" },
              {
                text: "We design lean, right-sized ERP implementations that reduce total cost of ownership while delivering faster time to value.",
              },

              { bold: true, text: "Built around your processes" },
              {
                text: "Every business operates differently. We tailor workflows, approvals, and reports to match your operating model so teams can work the way they already do, only better.",
              },

              { bold: true, text: "Visibility that drives decisions" },
              {
                text: "Integrated analytics and dashboards provide real-time insights across finance, operations, and performance enabling confident, data-driven decisions.",
              },

              { bold: true, text: "Flexible deployment and ownership" },
              {
                text: "Choose a fully managed SaaS model, shared cloud responsibility, or a build-and-handover approach that gives your team full control after stabilization.",
              },

              { bold: true, text: "End-to-end delivery" },
              {
                text: "From planning to post-go-live support, we manage the entire ERP journey ensuring continuity, adoption, and measurable ROI.",
              },
            ]}
          />

          <CustomAccordion
            title="Do you provide training and support?"
            description="Absolutely. We provide hands-on training, role-based learning, and 24/7 support to ensure smooth adoption."
          />

          <CustomAccordion
            title="Can ERP be customized for my business size?"
            description="Yes! ERP solutions can be tailored for small, medium, and large enterprises, ensuring scalability and flexibility."
          />

          <CustomAccordion
            title="What are the costs involved in ERP implementation?"
            description="Costs depend on factors like modules required, customization level, and user count. We provide transparent pricing after a detailed requirement analysis."
          />

          <CustomAccordion
            title="Is cloud-based ERP secure?"
            description="Absolutely. Our ERP solutions use advanced encryption, role-based access, and regular security updates to keep your data safe."
          />

          <CustomAccordion
            title="How do I know which ERP modules I need?"
            description="Our experts conduct a business process analysis to recommend the right modules for your operations."
          />

          <CustomAccordion
            title="Will ERP integrate with my existing software?"
            description="Yes. We offer integration services for popular tools like CRM, accounting software, e-commerce platforms, and more."
          />

          <CustomAccordion
            title="What industries benefit most from ERP?"
            description="ERP is versatile and supports Manufacturing, Retail & E-Commerce, Healthcare, Construction, Hospitality, IT services, Automotive, Food & Beverage, Wholesale & Distribution, Fresh Produce, Pharmaceuticals, Real Estate, Logistics & Supply Chain, Education, Finance & Accounting and more."
          />

          <CustomAccordion
            title="How soon can I see ROI after ERP implementation?"
            description="Most businesses experience efficiency gains and cost savings within 3–6 months post-implementation."
          />

          <CustomAccordion
            title="Do you offer on-premises and cloud ERP options?"
            description="Yes, we provide both deployment models based on your business needs and IT infrastructure."
          />

          <CustomAccordion
            title="What kind of support do you provide after go-live?"
            description="We offer 24/7 support, regular updates, and performance optimization to ensure smooth operations."
          /> */}
        </div>
        <div className="d-flex flex-column align-items-center text-center mt-5 custom-space custom-space-padding">
          <h5 className="main_heading mt-4">
            Ready to Transform How Your Business Operates?
          </h5>
          <p className="main_subheading pb-4">
            Let us discuss your ERP goals and identify the right implementation
            and ownership model for your organization.
          </p>
          <Buttons
            type="button"
            text="Request a Demo"
            onClick={() => navigate("/lets-talk")}
            variant="primary"
          />
        </div>
      </div>
    </>
  );
};

export default ERPSolutions;
